export default __webpack_public_path__ + "static/logo_ideapark-2c54150ee8b7df736e1a2cfce606703a.png";